import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide15RemoteSupport.css';

const bullets = [
  'AI-Powered Remote Diagnostics by Certified Engineers.',
  'Remote configuration checks with expert oversight',
  'Faster resolution with reduced downtime',
];

const audiences = ['Shipowners', 'Captains', 'Fleet managers', 'Shipyards'];

function Slide15RemoteSupport() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 18 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-remote-support">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="remote-support-bg">
        <div className="remote-support-grid" />
        <div className="remote-support-glow" />
        <div className="remote-support-rings" />
        <div className="remote-support-noise" />
      </div>

      <div className="remote-support-content">
        <motion.div className="remote-support-header" {...fadeUp(0.05)}>
          <h1 className="remote-support-title">
            Technical Remote
            <span>Support</span>
          </h1>
        </motion.div>

        <motion.ul className="remote-support-list" {...fadeUp(0.12)}>
          {bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </motion.ul>

        <motion.div className="remote-support-availability" {...fadeUp(0.2)}>
          <div className="remote-support-label">Available for</div>
          <div className="remote-support-tags">
            {audiences.map((label) => (
              <span key={label} className="remote-support-tag">{label}</span>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Slide15RemoteSupport;
